import { render, staticRenderFns } from "./SocialMediaForm.vue?vue&type=template&id=0d892009&scoped=true"
import script from "./SocialMediaForm.vue?vue&type=script&lang=ts"
export * from "./SocialMediaForm.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaForm.vue?vue&type=style&index=0&id=0d892009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d892009",
  null
  
)

export default component.exports